import React, { useState,useEffect } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { InputSearchClient,CardPerso } from '@gull';
import { Form } from "react-bootstrap";

export const Etat1 = (props) => {
    const t = useTranslate();

    const document_state={
        quotation:{
            index_name:['notExpired','expired'],
            label:['notExpired','expired']
        },
        billingDeposit:{
            index_name:['unUsed','partiallyUsed','used'],
            label:['unUsed','partiallyUsed','used']
        },
        purchaseOrderB2b:{
            index_name:['notCollected','collectInProgress','collected'],
            label:['notCollected','collectInProgress','collected']
        },
        deliveryNote:{
            index_name:['notDelivered','delivered'],
            label:['notDelivered2','delivered2']
        },
        billing:{
            index_name:['notAcquitte','partiallyAcquitte','acquitte'],
            label:['notAcquitte','partiallyAcquitte','acquitte']
        },
        billingBuy:{
            index_name:['notAcquitte','partiallyAcquitte','acquitte'],
            label:['notAcquitte','partiallyAcquitte','acquitte']
        },
        creditNote:{
            index_name:['unUsed','partiallyUsed','used'],
            label:['unUsed','partiallyUsed','used']
        },
        creditNoteBuy:{
            index_name:['unUsed','partiallyUsed','used'],
            label:['unUsed','partiallyUsed','used']
        },
        returnNote:{
            index_name:['notCollected','collectInProgress','collected'],
            label:['notCollected','collectInProgress','collected']
        },
    }

    useEffect(() => {
        const indexName = document_state[props.type]?.index_name;

        props.setPostParam(prev => ({
        ...prev,
        // si type invalide, on met un tableau vide (ou tu peux supprimer la clé)
        etat: indexName
        }));
    }, [props.type]);


    const handleChange = (e) => {
        const value = e.target.value;
        const checked = e.target.checked;

        props.setPostParam(prev => {
            let etat = prev.etat || [];

            if (checked) {
                // ajouter la valeur
                etat = [...etat, value];
            } else {
                // retirer la valeur
                etat = etat.filter(v => v !== value);
            }

            return {
                ...prev,
                etat
            };
        });
    }

    if(document_state[props.type]?.index_name){
        return (<>
            <label>{t('etat1')}</label>
            {document_state[props.type].index_name.map((value,index)=>{
                return(
                    <Form.Check
                        key={value}
                        type="switch"
                        checked={props.postParam.etat?.includes(value) || false}
                        value={value}
                        label={(t(document_state[props.type].label[index])) ? t(document_state[props.type].label[index]) : document_state[props.type].label[index]}
                        onChange={(e) => handleChange(e)}
                    />
                )
            }) 
            }
        </>)
    }


    return(<>&nbsp;</>)//on retourne un truc vide si jamais y a pas d'etat pour ce type de document
}

export const Etat2 = (props) => {
    const t = useTranslate();

    const document_state={
        quotation:{
            index_name:['notConverted','converted'],
            label:['notConverted','converted']
        },
        purchaseOrderB2b:{
            index_name:['notConverted','partiallyConverted','converted'],
            label:['notConverted','partiallyConverted','converted']
        },
        deliveryNote:{
            index_name:['notConverted','converted'],
            label:['isNotFactured','isFactured']
        },
        creditNote:{
            index_name:['notConverted','partiallyConverted','converted'],
            label:['notConverted','partiallyConverted','converted']
        }
    }

    useEffect(() => {
        const indexName = document_state[props.type]?.index_name;

        props.setPostParam(prev => ({
        ...prev,
        // si type invalide, on met un tableau vide (ou tu peux supprimer la clé)
        etat_conversion: indexName
        }));
    }, [props.type]);


    const handleChange = (e) => {
        const value = e.target.value;
        const checked = e.target.checked;

        props.setPostParam(prev => {
            let etat_conversion = prev.etat_conversion || [];

            if (checked) {
                // ajouter la valeur
                etat_conversion = [...etat_conversion, value];
            } else {
                // retirer la valeur
                etat_conversion = etat_conversion.filter(v => v !== value);
            }

            return {
                ...prev,
                etat_conversion
            };
        });
    }

    if(document_state[props.type]?.index_name){
        return (<>
            <label>{t('etat2')}</label>
            {document_state[props.type].index_name.map((value,index)=>{
                return(
                    <Form.Check
                        key={value}
                        type="switch"
                        checked={props.postParam.etat_conversion?.includes(value) || false}
                        value={value}
                        label={(t(document_state[props.type].label[index])) ? t(document_state[props.type].label[index]) : document_state[props.type].label[index]}
                        onChange={(e) => handleChange(e)}
                    />
                )
            }) 
            }
        </>)
    }


    return(<>&nbsp;</>)//on retourne un truc vide si jamais y a pas d'etat pour ce type de document
}

const FilterSearchBilling = (props) =>{
    const t = useTranslate();
    const [clientId,setClientId]=useState((props.defaultCustomer) ? props.defaultCustomer.id : ((props.defaultClientId) ? props.defaultClientId : false))
    const [justCancelled,setJustCancelled] = useState(false)

    const [postParam,setPostParam] = useState({
        type:props.defaultType,
        statut:'',
        cancelled:'excludeCancelled',
        other_company:props.defaultEntreprise
    })

    const [clientName,setClientName] = useState('')

    const handleChange = (e, name) => {
        const value = e.target.value;

        setPostParam(prev => {
            let newState = { ...prev };

            if (name === 'type') { // si on reset le type alors on reset les etats envoyés
                const { etat, etat_conversion, ...rest } = newState;
                newState = rest;
            }

            if (name === 'cancelled') { // si jamais on est sur du cancelled on reset les etat 
                if(e.target.value=='justCancelled'){
                    const { etat, etat_conversion, ...rest } = newState;
                    newState = rest;
                    setJustCancelled(true)
                }
                else setJustCancelled(false)
            }

            return {
                ...newState,
                [name]: value
            };
        });
    };

    const submitBilling = () =>{
        let data={}

        if(clientId) data['client']=clientId

        Object.entries(postParam).map(([key,value])=>{
            if(key=='etat' || key=='etat_conversion'){//permet de garantir que etat renvoie bien un tableau même vide
                data[key]=value
            }else{
                if(value!='') data[key]=value
            }
        })

        props.setExportParam(data)
        props.setReload(Date.now())
        props.setCurrentPage(1)
    }

    return (
        <CardPerso header={t('tableSearch')}>
            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label>{t('beginningPeriod')}</label>
                        <input type="date" className="form-control" onChange={(e)=>handleChange(e,'start')}/>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label>{t('endPeriod')}</label>
                        <input type="date" className="form-control" onChange={(e)=>handleChange(e,'end')} />
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <InputSearchClient
                            setClient={setClientId}
                            disabled={(props.disabled) ? true : false}
                            clientDetail={props.defaultCustomer}
                            from='facturation'
                            clientName={clientName}
                            setClientName={setClientName}
                        />
                    </div>
                </div>
                <div className='col-12 col-md-6 form-group'>
                    <select className='form-control' value={postParam.other_company} onChange={(e)=>handleChange(e,'other_company')}>
                        <option value="">{t('allCompany')}</option>        
                        <option value="null">{props.company.name}</option>                            
                        {Object.keys(props.company).length !=0 && props.company.other_company.length != 0 &&
                            props.company.other_company.map(value=>{
                                return(
                                    <option key={value.id} value={value.id}>{value.name}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className='col-12 col-md-6 form-group'>
                    <select className='form-control' value={postParam.type} onChange={(e)=>handleChange(e,'type')}>
                        <option value="">{t('allType')}</option>
                        <option value="creditNote">{t('creditNote')}</option>
                        <option value="purchaseOrderB2b">{t('purchaseOrderB2b')}</option>
                        <option value="deliveryNote">{t('deliveryNote')}</option>
                        <option value="returnNote">{t('returnNote')}</option>
                        <option value="quotation">{t('quotation')}</option>
                        <option value="billing">{t('billing')}</option>
                        <option value="billingBuy">{t('billingBuy')}</option>
                        <option value="creditNoteBuy">{t('creditNoteBuy')}</option>
                        <option value="billingDeposit">{t('billingDeposit')}</option>
                    </select>
                </div>
                <div className='col-12 col-md-6 form-group'>
                    <select className='form-control' value={postParam.cancelled} onChange={(e)=>handleChange(e,'cancelled')}>
                        <option value="excludeCancelled">{t('excludeCancelledDocument')}</option>
                        <option value="justCancelled">{t('justCancelledDocument')}</option>
                        <option value="includeCancelled">{t('includeCancelledDocument')}</option>
                    </select>
                </div>
                {(postParam.type!='' && !justCancelled) &&
                    <>
                        <div className='col-6 form-group'>
                            <Etat1 type={postParam.type} setPostParam={setPostParam} postParam={postParam}/>
                        </div>
                        <div className='col-6 form-group'>
                            <Etat2 type={postParam.type} setPostParam={setPostParam} postParam={postParam}/>
                        </div>
                    </>
                }
                <div className="col-12 mt-2">
                    <button disabled={props.validButton} className='btn btn-primary' onClick={()=>submitBilling()}>{props.validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}</button>
                </div>
            </div>
        </CardPerso>
    )
};

export default FilterSearchBilling;